export const DEFAULT_SLA_MINUTES = 1440;
export const DEFAULT_SLA_SECONDS = DEFAULT_SLA_MINUTES * 60;

export const EntryPointColumnWidth = '400px';
export const SlaColumnWidth = '120px';

import ChatFillIcon from '@ad-scripts/presentation/components/common/icons/fill/chat-fill';
import EmailFillIcon from '@ad-scripts/presentation/components/common/icons/fill/email-fill';
import { EndpointTypes } from 'src/models/Channels/endpointType';
import FacebookMessengerFillIcon from '@ad-scripts/presentation/components/common/icons/fill/facebook-messenger-fill';
import InstagramFillIcon from '@ad-scripts/presentation/components/common/icons/fill/instagram-fill';
import SmsFillIcon from '@ad-scripts/presentation/components/common/icons/stroke/sms-stroke';
import TwitterFillIcon from '@ad-scripts/presentation/components/common/icons/fill/twitter-fill';
import VoiceFillIcon from '@ad-scripts/presentation/components/common/icons/fill/voice-fill';
import WhatsappFillIcon from '@ad-scripts/presentation/components/common/icons/fill/whatsapp-fill';
import { CHAT_BRAND } from 'src/constants/branding';

export const EndpointsSections = {
  [EndpointTypes.CHAT]: {
    displayName: 'Chat',
    icon: ChatFillIcon,
    nameInDescription: `${CHAT_BRAND.name} messages`,
  },
  [EndpointTypes.EMAIL]: { displayName: 'Email', icon: EmailFillIcon, nameInDescription: 'emails' },
  [EndpointTypes.FB_MESSENGER]: {
    displayName: 'Facebook Messenger',
    icon: FacebookMessengerFillIcon,
    nameInDescription: 'messages',
  },
  [EndpointTypes.INSTAGRAM_DIRECT]: {
    displayName: 'Instagram Messaging',
    icon: InstagramFillIcon,
    nameInDescription: 'messages',
  },
  [EndpointTypes.INSTAGRAM_COMMENT]: {
    displayName: 'Instagram Comments',
    icon: InstagramFillIcon,
    nameInDescription: 'comments',
  },
  [EndpointTypes.SMS]: { displayName: 'SMS', icon: SmsFillIcon, nameInDescription: 'SMS messages' },
  [EndpointTypes.TWITTER]: {
    displayName: 'Twitter Direct Messages',
    icon: TwitterFillIcon,
    nameInDescription: 'messages',
  },
  [EndpointTypes.VOICE]: { displayName: 'Voice', icon: VoiceFillIcon, nameInDescription: 'voice calls' },
  [EndpointTypes.WHATSAPP]: { displayName: 'WhatsApp', icon: WhatsappFillIcon, nameInDescription: 'messages' },
};
